module.exports = __webpack_public_path__ + "static/media/header_parent.6f0bc3d8.png";